import { AxiosRequestHeaders, AxiosResponse } from 'axios';
import { endPoints } from '../../utils/apiEndpoints';
import axios from '../../redux/axiosInterceptor'

type Type = 'login' | 'signup';

export function requestGenerateOTP(data: any, type: Type) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: type === 'login' ? endPoints.login : endPoints.signup,
    data,
  });
}

export function requestVerifyOTP(data: any, headers: AxiosRequestHeaders) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.verifyOTP,
    headers,
    data,
  });
}

export function requestSetCurrentStep(data: any, headers: AxiosRequestHeaders) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.setStep,
    headers,
    data,
  });
}

export function requestGetCurrentStep(data: any, headers: AxiosRequestHeaders) : Promise<AxiosResponse> {
  return axios.request({
    method: 'get',
    baseURL: endPoints.base,
    url: endPoints.getStep,
    headers,
  });
}

export function requestGetUserDetails() : Promise<AxiosResponse> {
  return axios.request({
    method: 'get',
    baseURL: endPoints.base,
    url: endPoints.getUser,
  });
}

export function requestResendOtpMobile(data: any, headers: AxiosRequestHeaders) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.resendMobileOtp,
    headers,
    data,
  });
}

export function requestSetPreviousStep(data: any, headers: AxiosRequestHeaders) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.setPreviousStep,
    headers,
  });
}
